import React from 'react';

import { IConstructorGridItem } from '@/interfaces/constructor.interfaces';

export const getConstructorItemStyle = (item: IConstructorGridItem) => {
  const { id, blockStyle } = item;
  return {
    [`--perxis-auto-${id}-constructor-item-background-color-inner`]: `var(--perxis-auto-${id}-constructor-item-background-color, ${
      blockStyle?.backgroundColor ?? 'transparent'
    })`,

    ...blockStyle,
    backgroundColor: `var(--perxis-auto-${id}-constructor-item-background-color-inner)`,
  } as React.CSSProperties;
};
